import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ContextOperation } from "../../context/OperationContext";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import { AutoCompleteOption } from "../common/AutoComplete";
import { DeliveryNoteTable } from "./DeliveryNoteTable";
import { TransferRequestDetails } from "./navigationTabs/TransferRequestDetails";
import DeliveryNoteService from "./service/DeliveryNoteServices";

export const LocationContext = createContext<AutoCompleteOption[]>([]);

export const ManipulateLocation = (props: any) => {
  const { i18n } = useTranslation();
  const { tenant } = useContext(ContextOperation);
  const t = useOperationTranslation();
  const [getAllLocation, setAllLocation] = useState<AutoCompleteOption[]>([]);

  const addTypeToSentence = (type: string) => {
    switch (type) {
      case "PARKING_GO":
        return t("internOptionSelectName.physicalLocationType.parkingGo");
      case "LMS":
        return t("internOptionSelectName.physicalLocationType.lms");
      case "COMPOUND":
        return t("internOptionSelectName.physicalLocationType.compound");
      case "SHOP_REPAIR":
        return t("internOptionSelectName.physicalLocationType.shopRepair");
      default:
        return "";
    }
  };

  useEffect(() => {
    DeliveryNoteService.get
      .allLocation({
        tenant: tenant,
        pageNumber: 0,
        pageSize: 1000000,
      })
      .then((response) => {
        let array: AutoCompleteOption[] = [];
        response.content.map((element: any) =>
          array.push({
            label: `${element.locationEntityDesc} (${addTypeToSentence(
              element.type
            )})`,
            value: element.bpCode,
          })
        );
        setAllLocation(array);
      });
  }, [tenant, i18n.language]);
  
  //console.log(getAllLocation, "props.transferRequest allLocation");

  return (
    <LocationContext.Provider value={getAllLocation}>
      {props.children}
    </LocationContext.Provider>
  );
};

export default ManipulateLocation;
